var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomPlenaryIconColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#2FCCC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6252 35.7083C38.6252 37.3192 37.3193 38.625 35.7085 38.625H22.5835V26.9583H29.2711L27.3856 28.8438C26.8161 29.4133 26.8161 30.3367 27.3856 30.9062C27.9551 31.4757 28.8785 31.4757 29.448 30.9062L33.823 26.5312C34.1067 26.2476 34.249 25.8761 34.2502 25.5044L34.2502 25.5L34.2502 25.4956C34.2496 25.2995 34.2103 25.1125 34.1395 24.9418C34.0695 24.7725 33.9662 24.6138 33.8297 24.4755L34.1395 24.9418L33.8222 24.468L29.448 20.0938C28.8785 19.5243 27.9551 19.5243 27.3856 20.0938C26.8161 20.6633 26.8161 21.5867 27.3856 22.1562L29.2711 24.0417L22.5835 24.0417V12.375H35.7085C37.3193 12.375 38.6252 13.6808 38.6252 15.2917V35.7083Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2917 38.625C13.6808 38.625 12.375 37.3192 12.375 35.7083L12.375 15.2917C12.375 13.6808 13.6808 12.375 15.2917 12.375L22.5833 12.375L22.5833 38.625L15.2917 38.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomPlenaryIconColour);
export default __webpack_public_path__ + "static/media/CustomPlenaryIconColour.9b1d4f4bb1a771877f19c01105da459d.svg";
export { ForwardRef as ReactComponent };